<template>
<ul>
    <li
        v-for="(item, index) in supported_integrations"
        :key="'bullet:'+index"
    >
        <span
            v-if="item.on"
        >
            {{item.text}}
        </span>
        <span
            v-else
            style="color: rgba(0,0,0,0.5)"
        >
            {{item.text}}
        </span>
    </li>
    
</ul>
</template>

<script>
export default {
    props: {
        concept: {
            type: String,
            default: null,
        },
    },    

    computed: {
        supported_integrations() 
        {
            return this.$rc.enumValues('integration_name')
                .filter((el) => el.supports.includes(this.concept))
                .map((el) => { return { ... el, 'on': this.$rc.$state.isCRMEnabled(el.value)}})
                .sort((a,b) => a.text.localeCompare(b.text, 'en', {'sensitivity': 'base'}))
                ;
        }
    },
}
</script>

<style lang="scss" scoped>

</style>